<ng-container *ngIf="globalLoadingService.loading | async">
  <div class="bg-opacity-50 position-absolute min-vw-100 min-vh-100 d-flex justify-content-center align-items-center top-0">
    <div class="bg-dark border rounded-1 text-white fw-bolder display-4 px-4 py-3">
      Loading...
    </div>
  </div>
</ng-container>
